import { render } from "./MainPageInstructions.vue?vue&type=template&id=ca8470c0"
import script from "./MainPageInstructions.vue?vue&type=script&lang=js"
export * from "./MainPageInstructions.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Workplace\\WebFrameworks\\vuejs\\egg-picker\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__